import { Filter, FilterGroup, SelectList, SelectListMulti } from 'api-paths-cas';
import { flatten } from 'lodash';
import { useMemo } from 'react';
import { IFilter } from '@/store/filters/types';
import { ActiveFilter } from './ActiveFilter';

export const getList = (filter: Filter): SelectList | SelectListMulti => {
  if (filter?.options?.SELECT_MANY) {
    return filter.options.SELECT_MANY;
  }
  if (filter?.options?.SELECT_ONE) {
    return filter.options.SELECT_ONE;
  }
  if (filter?.options?.SELECT_MANY_MULTI) {
    return filter.options.SELECT_MANY_MULTI;
  }
  return [];
};

interface IActiveFiltersProps {
  activeFilters: IFilter;
  onClick?: (filter: Filter) => void;
  refreshRowsCallback?: () => void;
  options: FilterGroup[];
}

export const ActiveFilters = ({ activeFilters, onClick, options, refreshRowsCallback }: IActiveFiltersProps) => {
  const activeFiltersKeys = useMemo(
    () =>
      Object.keys(activeFilters).filter(item => {
        return activeFilters[item]?.length > 0;
      }),
    [activeFilters],
  );

  const allFilters = flatten(options.map(option => option.filters));

  const getFilterLabels = (filter: Filter): string[] => {
    if (filter.activeFilterLabel) {
      return [filter.activeFilterLabel()];
    }
    const list = getList(filter);

    const selectedValues = list.filter(item => {
      if (item.value instanceof Array) {
        const identifiedItem: boolean = item.value.some((i: string) => activeFilters[filter.key].includes(i));
        return identifiedItem;
      }
      const identifiedItem: boolean = activeFilters[filter.key].includes(item.value as string);
      return identifiedItem;
    });

    return selectedValues.map(item => item.label);
  };

  const getActiveFilter = (allFilters: Filter[], key: string): Filter => {
    const filterKeyMatch = allFilters.find(filter => filter.key === key);
    const numberMatch = allFilters.find(filter => filter.options.NUMBER_RANGE?.find(range => range.key === key));
    return filterKeyMatch ?? numberMatch;
  };

  const getUniqueActiveFilters = (activeFiltersKeys: string[]): Filter[] => {
    const allActiveFilters = activeFiltersKeys
      .map(activeFilterKey => {
        return getActiveFilter(allFilters, activeFilterKey);
      })
      .filter(Boolean);
    return [...new Set(allActiveFilters)];
  };

  return (
    <>
      {getUniqueActiveFilters(activeFiltersKeys).map(activeFilter => {
        const values = getFilterLabels(activeFilter);
        return values ? (
          <ActiveFilter
            key={`ActiveFilter-${activeFilter?.key}`}
            filter={activeFilter}
            values={values}
            onClick={onClick}
            refreshRowsCallback={refreshRowsCallback}
          />
        ) : null;
      })}
    </>
  );
};
